/* eslint-disable no-undef,no-unused-vars */
import Vue from 'vue'

import axios from '../services/axios'

const V = '5.103'

class VKApp {
  constructor({ appId }) {
    this.appId = appId
    this.logged = false
    this.inited = false
  }

  init() {
    this.inited = !!VK
    VK.init({
      apiId: this.appId,
    })
  }

  login() {
    return new Promise((resolve) => {
      if (this.logged) {
        resolve()
      } else {
        VK.Auth.login((data) => {
          this.data = data
          this.logged = true
          resolve(data)
        }, 4)
      }
    })
  }

  share({
    text, image, imgID, bigText,
  }) {
    if (!this.inited) return
    this.login()
      .then(() => {
        // eslint-disable-next-line camelcase
        VK.api('photos.getWallUploadServer', { v: V }, ({ response: { upload_url } }) => {
          axios.post('/share', {
            text, image, upload_server: upload_url, img_id: imgID, big_text: bigText,
          })
            .then(({ data: { server, hash, photo } }) => {
              // eslint-disable-next-line object-curly-newline
              VK.api('photos.saveWallPhoto', { v: V, hash, photo, server }, ({ response }) => {
                const [vkImg] = response
                VK.api('wall.post', {
                  message: `${text} \n https://урокцифры.рф/lesson/bolshie-dannye/`,
                  attachments: `photo${vkImg.owner_id}_${vkImg.id},https://xn--h1adlhdnlo2c.xn--p1ai/lesson/bolshie-dannye/`,
                }, (res) => { console.log(res) })
              })
            })
        })
      })
  }
}

const VKPlugin = {
  install(App, { appId }) {
    const vk = new VKApp({ appId })
    App.prototype.$vk = vk

    App.mixin({
      mounted() {
        vk.init()
      },
    })
  },
}

Vue.use(VKPlugin, { appId: '7195039' })
